import React from 'react';

import { EntitiesArray } from '../components/island';

import Player from '../functions/player';

export class Score extends React.Component {

  getTotalProvided(data){
    let PwrProdcution = data.getMwuServices();
    let PwrNeeded = data.getMwuNecessity();

    //Loop through purchases and add the value to totalPurchased
    if(data.purchasedMwu.length > 0) {
    	for (let i = 0; i < data.purchasedMwu.length; i++) {
    		PwrProdcution += parseInt(data.purchasedMwu[i].mwu, 10);
    	}
    }

    if(data.soldMwu.length > 0) {
    	for (let i = 0; i < data.soldMwu.length; i++) {
    		PwrProdcution -= parseInt(data.soldMwu[i].mwu, 10);
    	}
    }

    if (PwrNeeded <= 0) {
      return 100;
    }
    if (PwrProdcution <= 0 ) {
      return 0;
    }

    return (PwrProdcution / PwrNeeded) * 100;
  }

  // Calculate the Duurzaam;
  getTotalDurability(data){
    // get the GreenEnergy in %
    // green energy divided by the total energyproduction
    let greenProvided = (data.getMwuGreen() / data.getMwuServices()) * 100;
    if (!greenProvided) {
      greenProvided = 0;
    } else {
      if (greenProvided > 100) {
        greenProvided = 100;
      }
      if (greenProvided < 0) {
        greenProvided = 0;
      }
    }
    return greenProvided;
  }

  tableMaker(data){
    // Check if there is anything to make.
    if (data) {
      const table = [],
            dataType = data['type'];
      let roundNumber = Player.getData('round');

      // Setting the roundfactor
      if (roundNumber) {
        if (roundNumber === 1) {
          roundNumber = 1;
        } else if (roundNumber === 2) {
          roundNumber = 1.2;
        } else {
          roundNumber = 1.5;
        }
      }
      let returned = data.getExpensesGreen();

      let headerTitle = <th className="name">{data['name']}</th>;

      let samePosition = <tr><td colSpan="2"></td></tr>;
      if (this.props.endscore) {
        if(this.props.hideNumber !== true){
          headerTitle = <th className="name">{(this.props.dataKey > 2 ? ((this.props.data.displayPosition) +  ". ") : "" ) + data['name']}</th>;
        } else {
          headerTitle = <th className="name">{data['name']}</th>;
        }
      }

      switch (dataType) {
        case 'city':
        case 'company':

          let necessity = this.getTotalProvided(data);

          if (necessity > 100) {
            necessity = 100;
          }
          if (necessity < 0) {
            necessity = 0;
          }

          let usedGreenPower = data.getPercentageGreen();
          let scoreCompanyCity = (necessity + usedGreenPower ) * roundNumber;

          data['scores'] = data['scores'] || {};
          // If we have not yet calculated this player's score for this round before,
          // then we do that here & then set a flag (in this case the round's score, but it
          // could also just be a boolean).
          if (!data['scores'][`round${Player.getData('round')}`]) {
            // Increase player score.
            data['score'] += scoreCompanyCity;
            // Set a flag so the score is not increased again in the future.
            data['scores'][`round${Player.getData('round')}`] = scoreCompanyCity;
          }

          table.push(
            <table key={'companycity_table_' + this.props.dataKey}>
              <thead style={{backgroundColor: data.color}} key={'companycity_name_' + this.props.dataKey} >
                <tr>
                  { headerTitle }
                  <th className="score">{parseFloat(data['score']).toFixed(0)}</th>
                </tr>
              </thead>
              <tbody>
                <tr key={'companycity_totalProvided_' + this.props.dataKey}>
                  <td>Elektriciteitsvoorziening:</td>
                  <td>{necessity.toFixed(0)}%</td>
                </tr>
                <tr key={'companycity_totalDurability_' + this.props.dataKey}>
                  <td>Duurzaam:</td>
                  <td>{returned.percentageGreen.toFixed(0)}%</td>
                </tr>
                <tr key={'companycity_points_' + this.props.dataKey}>
                  <td>Score:</td>
                  <td>+{Math.floor(parseFloat(scoreCompanyCity)).toFixed(0)}</td>
                </tr>
                {samePosition}
              </tbody>
            </table>
          );

          break;

        case 'supplier':
          let completedAssignment;
          let assignmentText;

          // Check if assignments are met:
          if (data['name'] === "Wellectric") {

            // Zorg dat je de grootste leverancier van duurzame elektriciteit bent.
            let Wellectric = EntitiesArray[4].getMwuGreen(),
                Sonnelect = EntitiesArray[5].getMwuGreen();

            if (Wellectric > Sonnelect) {
              completedAssignment = 100;
              assignmentText = 'Ja';
            } else {
              completedAssignment = 0;
              assignmentText = 'Nee';
            }

          } else if (data['name'] === "Sonnelect") {

            // Bezit minimaal twee duurzame elektriciteitscentrales.
            let supplierServices = data.occupiedServiceSlots,
                greenServices = 0;

            for (var d = 0; d < supplierServices.length; d++) {
              if (supplierServices[d]['green'] === true) {
                greenServices += 1;
              }
            }
            // Check if assignment is met;
            if (greenServices >= 2) {
              completedAssignment = 100;
              assignmentText = 'Ja';
            } else {
              completedAssignment = 0
              assignmentText = 'Nee';
            }
          }

          let supplierScore = (  returned.percentageGreen  + parseInt(completedAssignment, 10) ) * roundNumber;

          data['scores'] = data['scores'] || {};
          // If we have not yet calculated this player's score for this round before,
          // then we do that here & then set a flag (in this case the round's score, but it
          // could also just be a boolean).
          if (!data['scores'][`round${Player.getData('round')}`]) {
            // Increase player score.
            data['score'] += supplierScore;
            // Set a flag so the score is not increased again in the future.
            data['scores'][`round${Player.getData('round')}`] = supplierScore;
          }

          table.push(
            <table key={'supplier_table_' + this.props.dataKey}>
              <thead style={{backgroundColor: data.color}} key={'supplier_name_' + this.props.dataKey}>
                <tr>
                  { headerTitle }
                  <th className="score">{parseInt(data['score'], 10).toFixed(0)}</th>
                </tr>
              </thead>
              <tbody>
                <tr key={'supplier_totalDurability_' + this.props.dataKey}>
                  <td>Duurzaam:</td>
                  <td>{returned.percentageGreen.toFixed(0)}%</td>
                </tr>
                <tr key={'supplier_assignment_' + this.props.dataKey}>
                  <td>Opdracht gehaald:</td>
                  <td>{assignmentText}</td>
                </tr>
                <tr key={'supplier_points_' + this.props.dataKey}>
                  <td>Score:</td>
                  <td>+{Math.floor(supplierScore).toFixed(0)}</td>
                </tr>
                {samePosition}
              </tbody>
            </table>
          );
          break;

        case 'government':

          // Calculate durability of Society
          let durabilitySociety = 0;
          for (var f = 0; f < 6; f++) {
            let returnedLoop = EntitiesArray[f].getExpensesGreen();
            durabilitySociety += returnedLoop.percentageGreen;
          }
          durabilitySociety = durabilitySociety / 6;

          let city2    = EntitiesArray[1],
              company2 = EntitiesArray[3],
              providedCity2 = this.getTotalProvided(city2),
              companyScores = 0;

          if (providedCity2 < 100) {

            let productionCompany2 = this.getTotalProvided(company2) - 10;
            if (productionCompany2 < 0 ) {
              productionCompany2 = 0;
            }
            companyScores += productionCompany2;
          } else {

            let productionCompany2 = this.getTotalProvided(company2);
            companyScores += productionCompany2;
          }

          // Vanderwaals
          let city1 = EntitiesArray[0],
              company1    = EntitiesArray[2],
              providedCity1    = this.getTotalProvided(city1);

          if (providedCity1 < 100) {

            let productionCompany1 = this.getTotalProvided(company1) - 10;
            if (productionCompany1 < 0 ) {
              productionCompany1 = 0;
            }
            companyScores += productionCompany1;
          } else {

            let productionCompany1 = this.getTotalProvided(data);
            companyScores += productionCompany1;
          }

          let islandGDP = companyScores / 2;
          // Calculate score of Government
          let governmentScore = (durabilitySociety + islandGDP) * roundNumber;

          data['scores'] = data['scores'] || {};
          // If we have not yet calculated this player's score for this round before,
          // then we do that here & then set a flag (in this case the round's score, but it
          // could also just be a boolean).
          if (!data['scores'][`round${Player.getData('round')}`]) {
            // Increase player score.
            data['score'] += governmentScore;
            // Set a flag so the score is not increased again in the future.
            data['scores'][`round${Player.getData('round')}`] = governmentScore;
          }

          table.push(
            <table key={'government_table_' + this.props.dataKey} >
              <thead style={{backgroundColor: data.color}} key={'government_name_' + this.props.dataKey}>
                <tr>
                  { headerTitle }
                  <th className="score">{parseInt(data['score'], 10).toFixed(0)}</th>
                </tr>
              </thead>
              <tbody>
                <tr key={'government_durability_' + this.props.dataKey}>
                  <td>Duurzaamheid Joulland:</td>
                  <td>{durabilitySociety.toFixed(0)}&#37;</td>
                </tr>
                <tr key={'government_gdp_' + this.props.dataKey}>
                  <td>BNP:</td>
                  <td>{islandGDP.toFixed(0)}</td>
                </tr>
                <tr key={'government_funds_' + this.props.dataKey}>
                  <td>Score:</td>
                  <td>+{Math.floor(governmentScore).toFixed(0)}</td>
                </tr>
                {samePosition}
              </tbody>
            </table>
          );
          break;

        case 'market':
          let profitRnd = Math.max( data['funds'], 0);
          let marketScore = ((profitRnd / 100) * 15 ) * roundNumber;
          data['scores'] = data['scores'] || {};
          // If we have not yet calculated this player's score for this round before,
          // then we do that here & then set a flag (in this case the round's score, but it
          // could also just be a boolean).
          if (!data['scores'][`round${Player.getData('round')}`]) {
            // Increase player score.
            data['score'] += marketScore;
            // Set a flag so the score is not increased again in the future.
            data['scores'][`round${Player.getData('round')}`] = marketScore;
          }

          table.push(
            <table key={'market_table_' + this.props.dataKey}>
              <thead style={{backgroundColor: data.color}} key={'market_name_' + this.props.dataKey}>
                <tr>
                  { headerTitle }
                  <th className="score">{parseInt(data['score'], 10).toFixed(0)}</th>
                </tr>
              </thead>
              <tbody>
                <tr key={'market_profit_' + this.props.dataKey}>
                  <td>Winst:</td>
                  <td>&#8364;{data['funds'].toFixed(0)}</td>
                </tr>
                <tr key={'market_points_' + this.props.dataKey}>
                  <td>Score:</td>
                  <td>+{Math.floor(marketScore).toFixed(0)}</td>
                </tr>
                {samePosition}
              </tbody>
            </table>
          );
          break;

        default:
          console.log('Default at: ', data);
      }
      if (this.props.show) {
        return table;
      }
    }
  }

  render() {
    if (this.props.show) {
      if(this.props.dataKey > 2) {
        return(
          <div className={"gameScore noCheer placeNo" + (this.props.dataKey + 1)}>
            { this.tableMaker(this.props.data, this.props.roundNumber) }
          </div>
        )
      } else {
        return(
          <div className={"gameScore cheer placeNo" + (this.props.dataKey + 1) + " displayPosition" + (this.props.data.displayPosition)}>
            { this.tableMaker(this.props.data, this.props.roundNumber) }
          </div>
        )
      }
    } else{
      return(
        <div>
          { this.tableMaker(this.props.data, this.props.roundNumber) }
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/score.js